import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';
import {BLUE_LIGHT, GRAY} from 'ui-library/Colors';

export interface PolymerCardProps {
  active: boolean;
  isOnlyCard: boolean;
  condensedContent?: JSX.Element;
  content: JSX.Element;
  onActivate: () => void;
  style: React.CSSProperties;
}

/**
 * @param active If the card is active
 * @param isOnlyCard If the card is the only one in the list
 * @param condensedContent Optional element to show if the card is inactive
 * @param content Elements to show if the card is active
 * @param onActivate Callback to set the card as active
 */
export function PolymerCard({
  active,
  isOnlyCard,
  condensedContent,
  content,
  onActivate,
  style,
}: PolymerCardProps): JSX.Element {
  // Since condensedContent is optional, fallback to the regular content when it is missing
  // and the card is inactive.
  const cardContent = !active ? (condensedContent ?? content) : content;
  return (
    <div
      className={css(styles.cardContent, active && !isOnlyCard && styles.active, !active && styles.clickable)}
      onClick={active ? undefined : onActivate}
      style={style}
      {...getTestProps({component: 'PolymerCard', element: 'root'})}
    >
      {cardContent}
    </div>
  );
}

const styles = StyleSheet.create({
  cardContent: {
    borderBottom: `1px solid ${GRAY}`,
    padding: '12px',
  },
  clickable: {
    cursor: 'pointer',
  },
  active: {
    borderLeftColor: BLUE_LIGHT,
    borderLeftWidth: '5px',
    borderLeftStyle: 'solid',
  },
});
